import React, { useState, forwardRef, useEffect } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TextField } from '@mui/material';
import { Box } from '@mui/system';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateOpeningStock = ({updateDialog, handleClose, row}) => {
  const [openingQty, setOpeningQty] = useState(0)
  useEffect(() => {
    if(row) {
      setOpeningQty(row.openingQty)
    }
  }, [row]);
  
  const updateStock = async() => {
    try {
      row.openingQty = openingQty
      handleClose();
    } catch (err) {
      console.log(err)
    }
  };

  return (
    <div>
      <Dialog
        open={updateDialog}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{width: "100vw"}}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Update Opening Stock
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="Opening Qty" variant="standard" fullWidth type="number" value={openingQty} onChange={(event) => setOpeningQty(event.target.value)}/></Grid>
            <Grid item xs={12}>
              <Button autoFocus variant="contained" onClick={updateStock} fullWidth>
              Update
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default UpdateOpeningStock
